/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "atzo",
      "-2": "herenegun",
      "0": "gaur",
      "1": "bihar",
      "2": "etzi",
      "future": {
        "one": "{0} egun barru",
        "other": "{0} egun barru"
      },
      "past": {
        "one": "duela {0} egun",
        "other": "duela {0} egun"
      }
    },
    "day-narrow": {
      "-1": "atzo",
      "-2": "herenegun",
      "0": "gaur",
      "1": "bihar",
      "2": "etzi",
      "future": {
        "one": "{0} egun barru",
        "other": "{0} egun barru"
      },
      "past": {
        "one": "duela {0} egun",
        "other": "duela {0} egun"
      }
    },
    "day-short": {
      "-1": "atzo",
      "-2": "herenegun",
      "0": "gaur",
      "1": "bihar",
      "2": "etzi",
      "future": {
        "one": "{0} egun barru",
        "other": "{0} egun barru"
      },
      "past": {
        "one": "duela {0} egun",
        "other": "duela {0} egun"
      }
    },
    "hour": {
      "0": "ordu honetan",
      "future": {
        "one": "{0} ordu barru",
        "other": "{0} ordu barru"
      },
      "past": {
        "one": "duela {0} ordu",
        "other": "duela {0} ordu"
      }
    },
    "hour-narrow": {
      "0": "ordu honetan",
      "future": {
        "one": "{0} ordu barru",
        "other": "{0} ordu barru"
      },
      "past": {
        "one": "duela {0} ordu",
        "other": "duela {0} ordu"
      }
    },
    "hour-short": {
      "0": "ordu honetan",
      "future": {
        "one": "{0} ordu barru",
        "other": "{0} ordu barru"
      },
      "past": {
        "one": "duela {0} ordu",
        "other": "duela {0} ordu"
      }
    },
    "minute": {
      "0": "minutu honetan",
      "future": {
        "one": "{0} minutu barru",
        "other": "{0} minutu barru"
      },
      "past": {
        "one": "duela {0} minutu",
        "other": "duela {0} minutu"
      }
    },
    "minute-narrow": {
      "0": "minutu honetan",
      "future": {
        "one": "{0} minutu barru",
        "other": "{0} minutu barru"
      },
      "past": {
        "one": "duela {0} minutu",
        "other": "duela {0} minutu"
      }
    },
    "minute-short": {
      "0": "minutu honetan",
      "future": {
        "one": "{0} minutu barru",
        "other": "{0} minutu barru"
      },
      "past": {
        "one": "duela {0} minutu",
        "other": "duela {0} minutu"
      }
    },
    "month": {
      "-1": "aurreko hilabetean",
      "0": "hilabete honetan",
      "1": "hurrengo hilabetean",
      "future": {
        "one": "{0} hilabete barru",
        "other": "{0} hilabete barru"
      },
      "past": {
        "one": "duela {0} hilabete",
        "other": "duela {0} hilabete"
      }
    },
    "month-narrow": {
      "-1": "aurreko hilabetean",
      "0": "hilabete honetan",
      "1": "hurrengo hilabetean",
      "future": {
        "one": "{0} hilabete barru",
        "other": "{0} hilabete barru"
      },
      "past": {
        "one": "duela {0} hilabete",
        "other": "duela {0} hilabete"
      }
    },
    "month-short": {
      "-1": "aurreko hilabetean",
      "0": "hilabete honetan",
      "1": "hurrengo hilabetean",
      "future": {
        "one": "{0} hilabete barru",
        "other": "{0} hilabete barru"
      },
      "past": {
        "one": "duela {0} hilabete",
        "other": "duela {0} hilabete"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "aurreko hiruhilekoa",
      "0": "hiruhileko hau",
      "1": "hurrengo hiruhilekoa",
      "future": {
        "one": "{0} hiruhileko barru",
        "other": "{0} hiruhileko barru"
      },
      "past": {
        "one": "duela {0} hiruhileko",
        "other": "duela {0} hiruhileko"
      }
    },
    "quarter-narrow": {
      "-1": "aurreko hiruhil.",
      "0": "hiruhil. hau",
      "1": "hurrengo hiruhil.",
      "future": {
        "one": "{0} hiruhileko barru",
        "other": "{0} hiruhileko barru"
      },
      "past": {
        "one": "duela {0} hiruhileko",
        "other": "duela {0} hiruhileko"
      }
    },
    "quarter-short": {
      "-1": "aurreko hiruhil.",
      "0": "hiruhil. hau",
      "1": "hurrengo hiruhil.",
      "future": {
        "one": "{0} hiruhileko barru",
        "other": "{0} hiruhileko barru"
      },
      "past": {
        "one": "duela {0} hiruhileko",
        "other": "duela {0} hiruhileko"
      }
    },
    "second": {
      "0": "orain",
      "future": {
        "one": "{0} segundo barru",
        "other": "{0} segundo barru"
      },
      "past": {
        "one": "duela {0} segundo",
        "other": "duela {0} segundo"
      }
    },
    "second-narrow": {
      "0": "orain",
      "future": {
        "one": "{0} segundo barru",
        "other": "{0} segundo barru"
      },
      "past": {
        "one": "duela {0} segundo",
        "other": "duela {0} segundo"
      }
    },
    "second-short": {
      "0": "orain",
      "future": {
        "one": "{0} segundo barru",
        "other": "{0} segundo barru"
      },
      "past": {
        "one": "duela {0} segundo",
        "other": "duela {0} segundo"
      }
    },
    "week": {
      "-1": "aurreko astean",
      "0": "aste honetan",
      "1": "hurrengo astean",
      "future": {
        "one": "{0} aste barru",
        "other": "{0} aste barru"
      },
      "past": {
        "one": "duela {0} aste",
        "other": "duela {0} aste"
      }
    },
    "week-narrow": {
      "-1": "aurreko astean",
      "0": "aste honetan",
      "1": "hurrengo astean",
      "future": {
        "one": "{0} aste barru",
        "other": "{0} aste barru"
      },
      "past": {
        "one": "duela {0} aste",
        "other": "duela {0} aste"
      }
    },
    "week-short": {
      "-1": "aurreko astean",
      "0": "aste honetan",
      "1": "hurrengo astean",
      "future": {
        "one": "{0} aste barru",
        "other": "{0} aste barru"
      },
      "past": {
        "one": "duela {0} aste",
        "other": "duela {0} aste"
      }
    },
    "year": {
      "-1": "iaz",
      "0": "aurten",
      "1": "hurrengo urtean",
      "future": {
        "one": "{0} urte barru",
        "other": "{0} urte barru"
      },
      "past": {
        "one": "duela {0} urte",
        "other": "duela {0} urte"
      }
    },
    "year-narrow": {
      "-1": "aurreko urtea",
      "0": "aurten",
      "1": "hurrengo urtea",
      "future": {
        "one": "{0} urte barru",
        "other": "{0} urte barru"
      },
      "past": {
        "one": "duela {0} urte",
        "other": "duela {0} urte"
      }
    },
    "year-short": {
      "-1": "aurreko urtea",
      "0": "aurten",
      "1": "hurrengo urtea",
      "future": {
        "one": "{0} urte barru",
        "other": "{0} urte barru"
      },
      "past": {
        "one": "duela {0} urte",
        "other": "duela {0} urte"
      }
    }
  },
  "locale": "eu"
})
}
